export const hasAgencyAccess = (user) =>
  Boolean(user?.company?.agenceId || user?.company?.agence);

export const isAgencyRoute = (pathname = "") =>
  pathname === "/chat" ||
  pathname.startsWith("/chat/") ||
  pathname.startsWith("/comptabilite");
